// 公共代币地址常量
export const TOKEN_ADDRESSES = {
  WBNB: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
  USDT: "0x55d398326f99059fF775485246999027B3197955", 
  USDC: "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d"
};

const contractAddress = process.env.REACT_APP_CA || "0xf5bE1f3Bd4DC1ed904293457f9EB57C7f5d91b3A";
// 预定义的参数组合配置
export const presetConfigurations = [
  {
    id: 'ab',
    name: '刷AB',
    fromTokenAddress: '0x95034f653D5D161890836Ad2B6b8cc49D14e029a',
    toTokenAddress: TOKEN_ADDRESSES.USDT,
    poolAddress: '0xD7af60112d7dfE0f914724E3407Dd54424AAA19b',
    contractAddress: contractAddress,
    desc:"路径:PCS Hub  slippage(滑点) 自定义0.05% ",
  },
  {
    id: 'SERAPH ',
    name: '刷SERAPH',
    fromTokenAddress: '0xd6B48CCF41a62EB3891e58D0F006B19B01d50cCa',
    toTokenAddress: TOKEN_ADDRESSES.USDT,
    poolAddress: '0xd5B642646A6E40090d5d61cA11A78eE2f6e0eF14',
    contractAddress: contractAddress,
    desc:"路径:PCS Hub  slippage(滑点) 自定义0.1% ",
  },
  {
    id: 'br ',
    name: '刷Br',
    fromTokenAddress: '0xff7d6a96ae471bbcd7713af9cb1feeb16cf56b41',
    toTokenAddress: TOKEN_ADDRESSES.USDT,
    poolAddress: '0x380aaDF63D84D3A434073F1d5d95f02fB23d5228',
    contractAddress: contractAddress,
    desc:"路径:PCS Hub  slippage(滑点) 自定义0.01% ",
  },
  {
    id: 'AiCell ',
    name: '刷AiCell',
    fromTokenAddress: '0xDe04da55B74435d7B9f2C5c62D9F1b53929b09AA',
    toTokenAddress: TOKEN_ADDRESSES.USDT,
    poolAddress: '0x430d8186BF67067c9d9EbA8899983dD1176a02D9',
    contractAddress: contractAddress,
    desc:"路径:PCS Hub  slippage(滑点) 自定义0.05% ",
  },
  {
    id: 'quq',
    name: '刷quq',
    fromTokenAddress: '0xd55C9fB62E176a8Eb6968f32958FeFDD0962727E',
    toTokenAddress: TOKEN_ADDRESSES.USDT,
    poolAddress: '0x9485Ff32b6b4444C21D5abe4D9a2283d127075a2',
    contractAddress: contractAddress,
    desc:"路径:PCS Hub  slippage(滑点) 自定义0.1% ",
  },
  {
    id: 'TAIKO ',
    name: '刷TAIKO',
    fromTokenAddress: '0x30C60b20C25b2810cA524810467A0c342294FC61',
    toTokenAddress: TOKEN_ADDRESSES.USDT,
    poolAddress: '0xBe77Ac86750FB0359fA623e63e7F009979BB701C',
    contractAddress: contractAddress,
    desc:"路径:PCS Hub  slippage(滑点) 自定义0.05% ",
  },
  {
    id: 'zkj-28',
    name: '刷ZKJ',
    fromTokenAddress: '0xC71B5F631354BE6853eFe9C3Ab6b9590F8302e81',
    toTokenAddress: TOKEN_ADDRESSES.USDT,
    poolAddress: '0x5968FEACbA91D55010975E0CFe8ACfc32664ad33',
    contractAddress: contractAddress,
    desc:"路径:PCS Hub  slippage(滑点) 自定义0.1% ",
    healthOverride:[{
      effentive:[0,0.75],
      label:"危险"
    }],
  },
  {
    id: 'koge-28',
    name: '刷KOGE(小心夹子)',
    fromTokenAddress: '0xe6DF05CE8C8301223373CF5B969AFCb1498c5528',
    toTokenAddress: TOKEN_ADDRESSES.USDT,
    poolAddress: '0xcF59B8C8BAA2dea520e3D549F97d4e49aDE17057',
    contractAddress: contractAddress,
    desc:"路径:PCS Hub  slippage 自定义0.1% ",
    healthOverride:[{
      effentive:[0,0.75],
      label:"危险"
    }],
  },
  {
    id: 'taiko',
    name: '交易赛刷TAIKO',
    fromTokenAddress: '0x30C60b20C25b2810cA524810467A0c342294FC61',
    toTokenAddress: TOKEN_ADDRESSES.USDT,
    poolAddress: '0xBe77Ac86750FB0359fA623e63e7F009979BB701C',
    contractAddress: contractAddress,
    desc:"路径:PCS Hub  slippage 自定义0.1% 最好有效流动性大于1%再刷",
     healthOverride:[{
      effentive:[0,0.005],
      label:"危险"
    },{
      effentive:[0,0.01],
      label:"还行"
    }],
  },
  {
    id: 'koge-zkj',
    name: '仅查看 (KOGE-ZKJ流动性)',
    fromTokenAddress: '0xC71B5F631354BE6853eFe9C3Ab6b9590F8302e81',
    toTokenAddress: "0xe6DF05CE8C8301223373CF5B969AFCb1498c5528",
    poolAddress: '0x099F84dE4Fb511e861cA8F635623Eae409405873',
    contractAddress: contractAddress,
    desc:"不要用这个来卖出",
  },
  {
    id: 'obt-28',
    name: '交易赛OBT-WBNB(高风险)',
    fromTokenAddress: '0xcef5b397051fc92026249670e918c0ad7b8585e4',
    toTokenAddress: TOKEN_ADDRESSES.WBNB,
    poolAddress: '0xd919Dc242Bb1E8A823Da9cdb9806E3D211265f47',
    contractAddress: contractAddress,
    desc:"路径:PCS Hub  slippage 自定义0.1% "
  },
  {
    id: 'bank-28',
    name: '交易赛BANK-WBNB(高风险)',
    fromTokenAddress: '0x3aee7602b612de36088f3ffed8c8f10e86ebf2bf',
    toTokenAddress: TOKEN_ADDRESSES.WBNB,
    poolAddress: '0xee6fF918A1f68B5d2FDEcb14b367FA2EB5C6951c',
    contractAddress: contractAddress,
    desc:" 路径:PCS Hub  slippage 自定义0.1% "
  },
  {
    id: 'agt-28',
    name: '交易赛AGT-WBNB(高风险)',
    fromTokenAddress: '0x5dbde81fce337ff4bcaaee4ca3466c00aecae274',
    toTokenAddress: TOKEN_ADDRESSES.WBNB,
    poolAddress: '0xD3cFFC6B02a34DfC72F1350339031043a854599f',
    contractAddress: contractAddress,
    desc:" 路径:PCS Hub  slippage 自定义0.1% "
  },
  {
    id: 'puffer',
    name: '交易赛PUFFER-USDC(高风险)',
    fromTokenAddress: '0x87d00066cf131ff54B72B134a217D5401E5392b6',
    toTokenAddress: TOKEN_ADDRESSES.USDC,
    poolAddress: '0x03F83FdFb168E7A2A621691E4B15297B1917ab91',
    contractAddress: contractAddress,
    desc:" 路径:PCS Hub  slippage 自定义0.1% "
  },
  {
    id: 'fhe',
    name: '交易赛FHE-WBNB(高风险)',
    fromTokenAddress: '0xd55C9fB62E176a8Eb6968f32958FeFDD0962727E',
    toTokenAddress: TOKEN_ADDRESSES.WBNB,
    poolAddress: '0x2bb75E055070aAa283B0F2070b0161B3F46f3c8c',
    contractAddress: contractAddress,
    desc:" 路径:PCS Hub  slippage 自定义0.1% "
  },
   {
    id: 'test',
    name: 'test',
    fromTokenAddress: TOKEN_ADDRESSES.WBNB,
    toTokenAddress: "0xc1353d3ee02fdbd4f65f92eee543cfd709049cb1",
    poolAddress: '0xd4732c8970D41766A30370233a7c6d75169f8fEc',
    contractAddress: contractAddress,
    desc:" test"
  }
];

export default presetConfigurations; 